export { default as AffirmWidget } from './affirmWidget'
